export const isProd = () => {
  if (typeof window !== "undefined") {
    return window.location.href.includes("asos.com");
  }

  return false;
};
